const initialState = {
    trialLoaded: false,
    data: {},

};

const trialAvailabilityReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'RECEIVED_TRIAL_CONTENT':
            return {
                ...state,
                trialLoaded: true,
                data: action.payload,

            };
        default:
            return state;
    }
};

export default trialAvailabilityReducer;
